import React from 'react'
import { type LucideProps } from 'lucide-react'

const AIChat: React.FC<LucideProps> = (props: LucideProps) => (
  <svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M11.9316 13.2588C12.215 11.4535 12.4984 9.67657 12.7817 7.87133C12.7817 7.23089 12.2438 6.85208 11.5065 6.85208C10.8545 6.85208 10.0608 7.17288 9.3811 7.87133C9.77739 7.7553 10.146 7.69615 10.4859 7.66771C10.8257 7.63813 11.1091 7.95892 11.0526 8.33774C10.7692 10.143 10.4859 11.92 10.2025 13.7252C10.2025 14.3656 10.7405 14.7445 11.4777 14.7445C12.1297 14.7445 12.9234 14.4237 13.6031 13.7252C13.2068 13.8412 12.8382 13.9004 12.4984 13.9288C12.1585 13.9584 11.8751 13.6376 11.9316 13.2588Z"
    fill="#949494"
  />
  <path
    d="M12.185 6.21172C12.7517 6.21172 13.2056 5.74531 13.2056 5.16288C13.2056 4.58045 12.7517 4.11404 12.185 4.11404C11.6182 4.11404 11.1643 4.58045 11.1643 5.16288C11.1654 5.74645 11.6182 6.21172 12.185 6.21172Z"
    fill="#949494"
  />
  <path
    d="M20.1202 0.475068H3.28758C1.6725 0.475068 0.368408 1.81512 0.368408 3.47487V15.3567C0.368408 17.0164 1.67244 18.3565 3.28758 18.3565H3.88314L2.89129 23.3072C2.86251 23.4528 2.92007 23.628 3.06176 23.7144C3.11822 23.744 3.17467 23.7724 3.25991 23.7724C3.34515 23.7724 3.4016 23.7428 3.48684 23.6848L10.3445 18.3553H20.1214C21.7364 18.3553 23.0405 17.0153 23.0405 15.3555L23.0394 3.47482C23.0394 1.81513 21.7353 0.475068 20.1202 0.475068ZM22.302 15.3567C22.302 16.6092 21.3102 17.5988 20.1202 17.5988H10.2016C10.1164 17.5988 10.0312 17.6284 9.97472 17.6864L3.79773 22.4915L4.67669 18.0653C4.70547 17.9493 4.67669 17.8321 4.59145 17.7445C4.53499 17.6569 4.42098 17.5989 4.30806 17.5989H3.25976C2.04097 17.5989 1.07791 16.5796 1.07791 15.3568L1.0768 3.47492C1.0768 2.22247 2.06865 1.2328 3.25865 1.2328H20.0913C21.31 1.2328 22.2731 2.25205 22.2731 3.47492L22.2742 15.3568L22.302 15.3567Z"
    fill="#949494"
  />
</svg>

)

export default AIChat
